import { appStore, AppStore } from './appStore';
import { branchStore, BranchStore } from './branchStore';
import { countriesStore, CountriesStore } from './countriesStore';
import { localeStore, LocaleStore } from './localesStore';
import { sidebarStore, SidebarStore } from './sidebarStore';
import { userStore, UserStore } from './userStore';
import integrationsStore, { IntegrationsStore } from 'src/mobx/integrationStore';

export enum STORES {
  APP_STORE = 'admin:appStore',
  INTEGRATIONS_STORE = 'admin:restrictionsStore',
  BRANCH_STORE = 'admin:branchStore',
  USER_STORE = 'admin:userStore',
  LOCALE_STORE = 'admin:localeStore',
  ORDER_STORE = 'admin:orderStore',
  // ORDERS_STORE = 'admin:ordersStore',
  ACTIVE_ORDER_INFO_STORE = 'admin:activeOrderInfoStore',
  SIDEBAR_STORE = 'admin:sidebarStore',
  PRODUCTS_STORE = 'admin:productsStore',
  COUNTRIES_STORE = 'admin:countriesStore',
}

export interface IMainStore {
  [STORES.APP_STORE]: AppStore;
  [STORES.INTEGRATIONS_STORE]: IntegrationsStore;
  [STORES.BRANCH_STORE]: BranchStore;
  [STORES.USER_STORE]: UserStore;
  [STORES.LOCALE_STORE]: LocaleStore;
  // [STORES.ORDER_STORE]: OrderStore;
  // [STORES.ORDERS_STORE]: OrdersStore;
  [STORES.SIDEBAR_STORE]: SidebarStore;
  [STORES.COUNTRIES_STORE]: CountriesStore;
}

const mainStore: IMainStore = {
  [STORES.APP_STORE]: appStore,
  [STORES.INTEGRATIONS_STORE]: integrationsStore,
  [STORES.BRANCH_STORE]: branchStore,
  [STORES.USER_STORE]: userStore,
  [STORES.LOCALE_STORE]: localeStore,
  // [STORES.ORDER_STORE]: orderStore,
  // [STORES.ORDERS_STORE]: ordersStore,
  [STORES.SIDEBAR_STORE]: sidebarStore,
  [STORES.COUNTRIES_STORE]: countriesStore,
};

export default mainStore;
